import {
  CheckSquare,
  Calendar,
  Mail,
  UserPlus,
  Target,
  FileText,
  ShoppingCart,
  Building2,
  Users,
  Package,
  FileImage,
  BookOpen,
  LucideIcon,
} from 'lucide-react'
import { CATEGORICAL } from '@/lib/theme'

export type EntityType =
  | 'task'
  | 'event'
  | 'email'
  | 'lead'
  | 'opportunity'
  | 'quote'
  | 'order'
  | 'account'
  | 'contact'
  | 'product'
  | 'pricebook'
  | 'content'

export interface EntityTypeConfig {
  label: string
  icon: LucideIcon
  /**
   * Key into the extended categorical palette (GRK-BRAND-1, see
   * docs/brand-decisions.md). Colour reinforces the icon-led identity; the badge
   * renders as the family `tint` fill with Prussian text/icon and a `solid`
   * border. Never used as coloured text on white.
   */
  category: keyof typeof CATEGORICAL
}

export const ENTITY_TYPES: Record<EntityType, EntityTypeConfig> = {
  task: { label: 'Task', icon: CheckSquare, category: 'navy' },
  event: { label: 'Event', icon: Calendar, category: 'evergreen' },
  email: { label: 'Email', icon: Mail, category: 'plum' },
  lead: { label: 'Lead', icon: UserPlus, category: 'pollen' },
  opportunity: { label: 'Opportunity', icon: Target, category: 'evergreen' },
  quote: { label: 'Quote', icon: FileText, category: 'teal' },
  order: { label: 'Order', icon: ShoppingCart, category: 'clay' },
  account: { label: 'Account', icon: Building2, category: 'prussian' },
  contact: { label: 'Contact', icon: Users, category: 'navy' },
  product: { label: 'Product', icon: Package, category: 'steel' },
  pricebook: { label: 'Pricebook', icon: BookOpen, category: 'slate' },
  content: { label: 'Content', icon: FileImage, category: 'plum' },
}
